import createReducer from 'utils/createReducer';

import { baseShipperOrder } from 'modules/shipper-order/Form/constants';

export const LOCALSTORAGE_ITEM = 'currentNewShipperOrder';
export const LOCALSTORAGE_ADDRESSES = 'currentAddresses';

const getStored = (key) => {
  const val = localStorage.getItem(key);
  return (val && val !== 'undefined' && JSON.parse(val)) || null;
};

// Initial State
const INIT_STATE = {
  opened: false,
  currentShipperOrder: getStored(LOCALSTORAGE_ITEM) || baseShipperOrder(),
  currentAddresses: getStored(LOCALSTORAGE_ADDRESSES) || [],
  recentlyCreatedShipperOrder: null,
  checkTimes: false,
  timeWarning: null,
  shipperWarning: null,
};

// Actions
const SET_OPENED = 'shipper-order-new/SET_OPENED';
const SET_CURRENT_SHIPPER_ORDER = 'shipper-order-new/SET_CURRENT_SHIPPER_ORDER';
const SET_RECENTLY_CREATED_SHIPPER_ORDER = 'shipper-order-new/SET_RECENTLY_CREATED_SHIPPER_ORDER';
const SET_CURRENT_ADDRESSES = 'shipper-order-new/SET_CURRENT_ADDRESSES';
const SET_APPEND_CURRENT_ADDRESSES = 'shipper-order-new/SET_APPEND_CURRENT_ADDRESSES';
const SET_SAVING_COST = 'shipper-order-new/SET_SAVING_COST';
const SET_CHECK_TIMES = 'shipper-order-new/SET_CHECK_TIMES';
const SET_TIME_WARNING = 'shipper-order-new/SET_TIME_WARNING';
const SET_DELETE_TIME_WARNING = 'shipper-order-new/SET_DELETE_TIME_WARNING';
const SET_SHIPPER_WARNING = 'shipper-order-new/SET_SHIPPER_WARNING';
const SET_DELETE_SHIPPER_WARNING = 'shipper-order-new/SET_DELETE_SHIPPER_WARNING';

// Reducers
export default createReducer(INIT_STATE, {
  [SET_OPENED](state, payload) {
    return {
      ...state,
      opened: payload,
    };
  },
  [SET_CURRENT_SHIPPER_ORDER](state, payload) {
    return {
      ...state,
      currentShipperOrder: payload,
    };
  },
  [SET_RECENTLY_CREATED_SHIPPER_ORDER](state, payload) {
    return {
      ...state,
      recentlyCreatedShipperOrder: payload,
    };
  },
  [SET_CURRENT_ADDRESSES](state, payload) {
    return {
      ...state,
      currentAddresses: payload,
    };
  },
  [SET_APPEND_CURRENT_ADDRESSES](state, payload) {
    return {
      ...state,
      currentAddresses: [...state.currentAddresses, ...payload],
    };
  },
  [SET_SAVING_COST](state, payload) {
    return {
      ...state,
      savingCost: payload,
    };
  },
  [SET_CHECK_TIMES](state, payload) {
    return {
      ...state,
      checkTimes: payload,
    };
  },
  [SET_TIME_WARNING](state, payload) {
    return {
      ...state,
      timeWarning: [...(state.timeWarning || []), payload],
    };
  },
  [SET_DELETE_TIME_WARNING](state) {
    return {
      ...state,
      timeWarning: null,
    };
  },
  [SET_SHIPPER_WARNING](state, payload) {
    return {
      ...state,
      shipperWarning: payload,
    };
  },
  [SET_DELETE_SHIPPER_WARNING](state) {
    return {
      ...state,
      shipperWarning: null,
    };
  },
});

// Action creators
export const setOpened = (payload) => ({
  type: SET_OPENED,
  payload: payload,
});

export const setCurrentShipperOrder = (payload) => ({
  type: SET_CURRENT_SHIPPER_ORDER,
  payload: payload,
});

export const setRecentlyCreatedShipperOrder = (payload) => ({
  type: SET_RECENTLY_CREATED_SHIPPER_ORDER,
  payload: payload,
});

export const setCurrentAddresses = (payload) => ({
  type: SET_CURRENT_ADDRESSES,
  payload: payload,
});

export const setAppendCurrentAddresses = (payload) => ({
  type: SET_APPEND_CURRENT_ADDRESSES,
  payload: payload,
});

export const setSavingCost = (payload) => ({
  type: SET_SAVING_COST,
  payload: payload,
});

export const setCheckTimes = (payload) => ({
  type: SET_CHECK_TIMES,
  payload,
});

export const setTimeWarning = (payload) => ({
  type: SET_TIME_WARNING,
  payload,
});

export const setDeleteTimeWarning = (payload) => ({
  type: SET_DELETE_TIME_WARNING,
  payload,
});

export const setShipperWarning = (payload) => ({
  type: SET_SHIPPER_WARNING,
  payload,
});

export const setDeleteShipperWarning = (payload) => ({
  type: SET_DELETE_SHIPPER_WARNING,
  payload,
});
